import React from 'react'
import { Breadcrumb } from "@chakra-ui/react"

const BreadCrumbBox = (props) => {
    const { navPageList = [], currentPage = '' } = props;
  return (
    <Breadcrumb.Root>
        <Breadcrumb.List>
            {navPageList.map((item)=>(
                <React.Fragment key={item.id} >
                    <Breadcrumb.Item>
                        <Breadcrumb.Link onClick={item.onClick} cursor={"pointer"}>
                        {item.icon ? item.icon : null }
                        {item.pageName}
                        </Breadcrumb.Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Separator />
                </React.Fragment>
            ))}
            <Breadcrumb.Item>{currentPage}</Breadcrumb.Item>
        </Breadcrumb.List>
    </Breadcrumb.Root>
  )
}

export default BreadCrumbBox
